import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { HealthForm } from '@models/MLTC/Health.model';


export const validate = (values: HealthForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'q1':
    case 'q2':
    case 'q3':
    case 'q4':
    case 'q5':
      if (isNil(value)) {
        error = { isValid: false };
      }
      break;
    case 'height':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minHeight = 75, maxHeight = 250;
          const isOutOfRangeHeight = Validations.isInRange(Number(value), minHeight, maxHeight);
          if (isOutOfRangeHeight !== 0) {
            error = { isValid: false, message: `Please enter a valid height from ${minHeight}cm to ${maxHeight}cm` };
          }
        }
      }
      break;
    case 'weight':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: `This field cannot be empty` };
        } else {
          const minWeight = 25, maxWeight = 200;
          const isOutOfRangeWeight = Validations.isInRange(Number(value), minWeight, maxWeight);
          if (isOutOfRangeWeight !== 0) {
            error = { isValid: false, message: `Please enter a valid weight from ${minWeight}kg to ${maxWeight}kg` };
          }
        }
      }
      break;
    default:
      break;
  }
  return error;
}
